import type { AutocompleteSuggestionPart } from '@dynatrace-sdk/client-query';

import { DQL_DOCUMENTATION_URL_PREFIX } from '../../../core/external-links.js';
import { ExternalLink } from '../../../typography/external-link/ExternalLink.js';

/**
 * Generates URLs to the docs for DQL commands and functions.
 * Maps supported token types to static URL parts ('COMMAND_NAME' to 'command', 'FUNCTION_NAME' to 'function', 'TIMESERIES_AGGREGATION' to 'timeseries').
 * FIXME: This is a tempory solution (EXA-4874) and will be replaced by URLs provided by the server (EXA-5121).
 * @param suggestion - the autocomplete suggestion as returned by the endpoint
 * @returns the generated URL, or 'undefined' if any other token type then 'COMMAND_NAME' or 'FUNCTION_NAME'
 */
export function generateDocumentationLink(
  suggestion: AutocompleteSuggestionPart | undefined,
): string | undefined {
  const supportedTypes = new Map<string, string>();
  supportedTypes.set('COMMAND_NAME', 'command');
  supportedTypes.set('FUNCTION_NAME', 'function');
  supportedTypes.set('TIMESERIES_AGGREGATION', 'timeseries');

  if (
    !suggestion?.type ||
    !Array.from(supportedTypes.keys()).includes(suggestion.type)
  ) {
    return undefined;
  }

  const encoded = encodeURI(
    `${supportedTypes.get(suggestion.type)}_${suggestion.suggestion}`,
  );

  return `${DQL_DOCUMENTATION_URL_PREFIX}${encoded}`;
}

export const DocumentationLink = ({
  suggestionPart,
}: {
  suggestionPart: AutocompleteSuggestionPart | undefined;
}) => {
  const docUrl = generateDocumentationLink(suggestionPart);
  return docUrl ? (
    <ExternalLink href={docUrl} data-dt-name="LearnMore">
      Learn more
    </ExternalLink>
  ) : null;
};
